import React, { useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons"; // Importamos el ícono
import { useNavigate } from "react-router-dom";
import './BuscadorStyle.scss';

const Buscador = () => {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    navigate(`/buscador?search=${searchText}`);
  };

  return (
      <Input
        placeholder="Buscar en Blizu"
        allowClear
        size="large"
        // En lugar de onSearch, usamos onPressEnter para detectar el "Enter"
        onPressEnter={handleSearch} 
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
        // Agregamos el ícono a la izquierda (prefix) o derecha (suffix)
        // Se ve más moderno a la izquierda (prefix) para estilo píldora
        prefix={<SearchOutlined style={{ color: '#9ca3af', marginRight: 8 }} />} 
        className="search-pill-input" 
        style={{ width: "100%" }}
      />
  );
};

export default Buscador;